export default __webpack_public_path__ + "static/media/baseCalculator.444bfac3.JPG";